import { ResponseError } from "app/services/fetchService";

export const FORBIDDEN_SALES_WORKSPACE_LIST_MESSAGE_PATTERN =
    /Request failed with status:\s*403 for url:\s*\/sales-api\/workspace(?:\?|$)/;

export const isForbiddenSalesWorkspaceListResponseError = (error: unknown): boolean => {
    const matches = (e: unknown): boolean =>
        e instanceof ResponseError &&
        e.status === 403 &&
        FORBIDDEN_SALES_WORKSPACE_LIST_MESSAGE_PATTERN.test(e.message);

    if (matches(error)) {
        return true;
    }

    if (error instanceof Error && matches(error.cause)) {
        return true;
    }

    return false;
};

export const isForbiddenSalesWorkspaceListMessage = (message: string | undefined): boolean =>
    Boolean(message && FORBIDDEN_SALES_WORKSPACE_LIST_MESSAGE_PATTERN.test(message));
